import { Button } from "antd";
import Playstoreimg from "../../../assests/solutionImages/appdownloadimg/Playstore.svg";
import Appstoreimg from "../../../assests/solutionImages/appdownloadimg/Appstore.svg";

function AppdownloadTheme({ card }) {
  // console.log(card);

  return (
    <div className="flex p-2 min-h-screen md:py-4 justify-center">
      <div className="relative bg-gray-600 rounded-lg shadow-lg overflow-hidden font-poppins max-w-[393px]">
        <div className="bg-[#EEEEEE] w-full py-[7rem]">
          <h1 className="text-center text-2xl font-bold w-full break-all break-words">
            {card?.data?.appName}
          </h1>
          <p className="text-center text-md w-full break-all break-words">
            {card?.data?.developer}
          </p>
        </div>

        {card?.data?.isProfileVisible && card?.profileImage && (
          <div className="absolute top-[18rem] left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <img
              src={card.profileImage}
              alt="Profile"
              className="w-24 h-24 rounded-full object-cover"
            />
          </div>
        )}

        <div className="text-center pt-[6rem] px-[3rem]">
          <h2 className="text-3xl font-bold text-white break-all break-words">{card?.data?.title}</h2>
          <p className="text-[#D0D0D0] px-10 py-3 break-all break-words">{card?.data?.summary}</p>
          <div className="px-[3rem] rounded-lg py-[2rem]">
            <Button
              className="w-full h-full bg-custom-gradient rounded py-2 hover:opacity-90 transition-opacity break-all break-words"
              type="primary"
              onClick={() => window.open(card?.data?.buttonLink || card?.data?.websiteLink, "_blank")}
            >
              {card?.data?.buttonLabel}
            </Button>
          </div>
          <p className="text-[#D0D0D0] px-10 py-3 break-all break-words">Download App from Store</p>
        </div>

        <div className="flex justify-center items-center gap-4 px-5 pb-4">
          {card?.data?.isPlayStoreVisible && (
            <a
              href={card?.data?.playStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img src={Playstoreimg} alt="Play Store" />
            </a>
          )}
          {card?.data?.isAppleStoreVisible && (
            <a
              href={card?.data?.appStoreLink}
              target="_blank"
              rel="noopener noreferrer"
              className="hover:opacity-80 transition-opacity"
            >
              <img src={Appstoreimg} alt="App Store" />
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default AppdownloadTheme;
